import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { hexToNumber } from '../index.js';
function formatStorageProof(storageProof) {
  return storageProof.map(proof => _objectSpread(_objectSpread({}, proof), {}, {
    value: BigInt(proof.value)
  }));
}
export function formatProof(proof) {
  return _objectSpread(_objectSpread({}, proof), {}, {
    balance: proof.balance ? BigInt(proof.balance) : undefined,
    nonce: proof.nonce ? hexToNumber(proof.nonce) : undefined,
    storageProof: proof.storageProof ? formatStorageProof(proof.storageProof) : undefined
  });
}
//# sourceMappingURL=proof.js.map